if (!customElements.get('als-legal-guarantee')) {
  customElements.define('als-legal-guarantee', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      this.querySelector('[data-guarantee-open]').addEventListener('click', event => {
        if (typeof dialog.showModal !== 'function') return;
        event.preventDefault(); dialog.showModal();
      });
      this.querySelector('[data-guarantee-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if(event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
    }
  });
}
